import { Controller } from '@hotwired/stimulus'

// Manual "point to another number" for an admin. On open, lazily fetches the
// numbers that are members of ALL the admin's groups and shows a native <select>;
// picking one repoints via POST. DOM is built with createElement (no innerHTML).
export default class extends Controller {
  static values = { adminId: String, eligibleUrl: String, setUrl: String }

  async open() {
    this.element.textContent = 'carregando…'
    try {
      const res = await fetch(`${this.eligibleUrlValue}?real_estate_admin_id=${this.adminIdValue}`, {
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      })
      const { numbers } = await res.json()
      this.renderSelect(numbers || [])
    } catch (error) {
      console.error('eligible numbers failed:', error)
      this.element.textContent = 'erro ao carregar'
    }
  }

  renderSelect(numbers) {
    const select = document.createElement('select')
    select.className = 'rounded border border-gray-300 text-xs px-1.5 py-1'

    const placeholder = document.createElement('option')
    placeholder.textContent = numbers.length ? 'Escolher número…' : 'Nenhum número elegível'
    placeholder.disabled = true
    placeholder.selected = true
    select.appendChild(placeholder)

    numbers.forEach((n) => {
      const option = document.createElement('option')
      option.value = n.maytapi_id
      option.textContent = `${n.number} (#${n.maytapi_id})`
      select.appendChild(option)
    })

    if (numbers.length) select.addEventListener('change', () => this.apply(select.value))
    this.element.replaceChildren(select)
  }

  async apply(maytapiId) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const res = await fetch(this.setUrlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': token,
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ real_estate_admin_id: this.adminIdValue, maytapi_id: maytapiId }),
      })
      if (res.ok) {
        const { maytapi_id: applied } = await res.json()
        this.element.textContent = `maytapi ${applied} ✓`
      } else {
        this.element.textContent = 'não permitido'
      }
    } catch (error) {
      console.error('set number failed:', error)
      this.element.textContent = 'falhou'
    }
  }
}
